let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dP2Uj")).then(() => parcelRequire('ee1yi'));